import { getBodyListNames } from "./listBodyUtils";
import jsondata from '../assets/elements.json';

function checkAllRequiredElements() {
    this.missingTypes = [];
    checkForMissingGlobalTypes.call(this);
    getBodyListNames().forEach(listName => checkRequiredInPageBody.call(this, listName));
}

function checkForMissingGlobalTypes() {
    jsondata.globalTypes.forEach(type => this.state[type].length <= 0 && this.missingTypes.push(type))
}

function checkRequiredInPageBody(listName) {
    const requiredElementsForBody = getRequiredElementsForBody(listName);

    let bodyIsMissingRequiredElement = false;
    requiredElementsForBody.forEach(required => {
        let added;
        if (Array.isArray(required)) {
            added = checkRequiredAtLeastOneOfInArray.call(this, listName, required);
        } else {
            added = checkRequiredString.call(this, listName, required);
        }

        bodyIsMissingRequiredElement |= !added;
        
    })
    this.pageBodiesMissingRequiredElements[listName] = bodyIsMissingRequiredElement;
}

const getRequiredElementsForBody = (listName) => {
    const requiredElements = jsondata.requiredTypes[listName];
    if (!Array.isArray(requiredElements)) {
        throw new TypeError(`${listName} has no required types defined, check src/assets/elements.json`);
    }

    return requiredElements;
};

function checkRequiredAtLeastOneOfInArray(listName, required) {
    const added = this.state[listName].findIndex(elem => required.findIndex(req => req === elem.type) !== -1) !== -1;
    if(!added) {
        this.missingTypes.push(...required);
    }
    return added;
}

function checkRequiredString(listName, required) {
    const added = this.state[listName].findIndex(elem => elem.type === required) !== -1;
    if(!added) {
        this.missingTypes.push(required);
    }
    return added;
}

export { checkAllRequiredElements };